import type { AppRole } from "@/hooks/useUserRoles";

const QBO_FINANCE_READ_ROLES = new Set<AppRole>([
  "finance",
  "finance_admin",
  "bookkeeper",
  "treasurer",
  "auditor",
  "super_admin",
  "platform_super_admin",
]);
const QBO_FINANCE_MANAGE_ROLES = new Set<AppRole>([
  "finance",
  "finance_admin",
  "super_admin",
  "platform_super_admin",
]);

export function hasQboFinanceReadAccess(
  appRoles: AppRole[],
  isOrgAdmin: boolean,
): boolean {
  return isOrgAdmin || appRoles.some((role) => QBO_FINANCE_READ_ROLES.has(role));
}

export function hasQboFinanceManageAccess(
  appRoles: AppRole[],
  isOrgAdmin: boolean,
): boolean {
  return isOrgAdmin || appRoles.some((role) => QBO_FINANCE_MANAGE_ROLES.has(role));
}
